import marketingUtility from '@sparta.auto-loans.utilities/marketing-code-utility/dist/es6.js';

/**
 * The prequal marketing code utility class which finds all prequal-link class
 * links on page load then ensures they have the applicable marketing codes.
 */
class PrequalMarketingCodeUtility {
  /**
   * Called on page load
   * @returns {void}
   */
  init() {
    document.querySelectorAll('a.prequal-link').forEach(elem => {
      marketingUtility.appendMarketingCode(elem);
    });
  }
}
const vlpqMarketingCodeUtility = new PrequalMarketingCodeUtility();

export { PrequalMarketingCodeUtility, vlpqMarketingCodeUtility as default };
